 import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PMNoteDialog } from '../../PMNotesModel/PMNoteDialog';
import { PMNotesModel, PMComponentModel, PMPartsModel } from './PMNotesModel';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'pmnotes',
  templateUrl: './PMNotesComponent.html'
})
export class PMNotesComponent {
  noteDialogRef!: MatDialogRef<PMNoteDialog>;

  public NoteList: PMNotesModel[] = [];
  public componentDetails = new PMComponentModel();
  public notesDetails = new PMNotesModel();
  public partsDetails = new PMPartsModel();

  PrevParts: any[] = [];
  @Input() isValidForm: boolean = false;

  @Output() addNoteClick = new EventEmitter<boolean>();
  @Output() openNoteClick = new EventEmitter<boolean>();
  @Output() CheckValidForm = new EventEmitter<boolean>();

  constructor(public dialog: MatDialog, private breakpointObserver: BreakpointObserver) {}

  ngOnInit() {}

  // Save Notes
  // onNoteSave($event: any) {
  //   if (this.notesDetails.description) {
  //     this.NoteList.push({ ...this.notesDetails });
  //   }

  //   if (this.componentDetails.showParts) {

  //     const parts = [...this.noteDialogRef.componentInstance.NoteParts.PartTrans];

  //     this.componentDetails.AllParts = this.componentDetails.AllParts
  //       .filter(x => x.questionId !== this.notesDetails.questionId);

  //     this.componentDetails.AllParts = [...this.componentDetails.AllParts, ...parts];
  //   }

  //   this.addNoteClick.emit(true);
  // }

  onNoteSave($event: any) {
     if (this.notesDetails.description) {
      this.NoteList.push({ ...this.notesDetails });
    }
    if (this.componentDetails?.showParts) {

      // Extract selected parts from dialog (safe clone)
      const parts = [...(this.noteDialogRef?.componentInstance?.NoteParts?.PartTrans ?? [])];

      const qId = this.notesDetails?.questionId;

      // Remove existing parts only if questionId is valid (not blank/null/undefined)
      this.componentDetails.AllParts = (this.componentDetails.AllParts ?? [])
        .filter(p => qId ? p.questionId !== qId : true);

      // Add new parts
      this.componentDetails.AllParts = [
        ...this.componentDetails.AllParts,
        ...parts.map(p => ({ ...p }))  // deep clone to avoid reference issues
      ];
    }
    this.addNoteClick.emit(true);
  }

  // Open Notes List
  openNotes() {
    this.openNoteClick.emit(true);
  }

  // Add new Note
  public AddNote() {
    this.CheckValidForm.emit();

    setTimeout(() => {
      // If form is valid externally, skip dialog
      if (this.isValidForm === true) {
        this.addNoteClick.emit(true);
        return;
      }
      const isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);

      // Open dialog
      this.noteDialogRef = this.dialog.open(PMNoteDialog, {
        disableClose: true,
        position: { right: '0', top: '0' },
        height: '100%',
        //width: '90%'
        width: isMobile ? '100vw' : '90%',
        maxWidth: isMobile ? '100vw' : '90vw',
      });

      // Set dialog input properties
      const instance = this.noteDialogRef.componentInstance;
      instance.notesDetails = this.notesDetails;
      instance.componentDetails = this.componentDetails;

      if (this.componentDetails.showParts) {
        instance.partsDetails = this.partsDetails;
      }

      // Subscribe to dialog save event
      instance.SaveEvent.subscribe(evt => this.onNoteSave(evt));

      // After dialog closed
      this.noteDialogRef.afterClosed().subscribe(() => {
        this.noteDialogRef = null!;
      });

    }, 500);
  }
}
